// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/kycb/api/kyb/firstparty/v1/get.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";

/** Enum for KYB status. */
export const ApiKybStatus = {
  /** KYB_STATUS_UNSPECIFIED - Unspecified status. */
  KYB_STATUS_UNSPECIFIED: "KYB_STATUS_UNSPECIFIED",
  /**
   * pending - KYB is not started.
   */
  pending: "pending",
  /**
   * accepted - KYB is accepted.
   */
  accepted: "accepted",
  /**
   * refused - KYB is refused.
   */
  refused: "refused",
} as const;

export type ApiKybStatus = typeof ApiKybStatus[keyof typeof ApiKybStatus];

export namespace ApiKybStatus {
  export type KYB_STATUS_UNSPECIFIED = typeof ApiKybStatus.KYB_STATUS_UNSPECIFIED;
  export type pending = typeof ApiKybStatus.pending;
  export type accepted = typeof ApiKybStatus.accepted;
  export type refused = typeof ApiKybStatus.refused;
}

export function apiKybStatusFromJSON(object: any): ApiKybStatus {
  switch (object) {
    case 0:
    case "KYB_STATUS_UNSPECIFIED":
      return ApiKybStatus.KYB_STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiKybStatus.pending;
    case 2:
    case "accepted":
      return ApiKybStatus.accepted;
    case 3:
    case "refused":
      return ApiKybStatus.refused;
    default:
      return ApiKybStatus.KYB_STATUS_UNSPECIFIED;
  }
}

export function apiKybStatusToJSON(object: ApiKybStatus): string {
  switch (object) {
    case ApiKybStatus.KYB_STATUS_UNSPECIFIED:
      return "KYB_STATUS_UNSPECIFIED";
    case ApiKybStatus.pending:
      return "pending";
    case ApiKybStatus.accepted:
      return "accepted";
    case ApiKybStatus.refused:
      return "refused";
    default:
      return "KYB_STATUS_UNSPECIFIED";
  }
}

/** Enum for flex kyb status. */
export const ApiFlexKybStatus = {
  /** FLEX_KYB_STATUS_UNSPECIFIED - Unspecified status. */
  FLEX_KYB_STATUS_UNSPECIFIED: "FLEX_KYB_STATUS_UNSPECIFIED",
  /**
   * flex_kyb_waiting - Waiting for FLEX KYB.
   */
  flex_kyb_waiting: "flex_kyb_waiting",
} as const;

export type ApiFlexKybStatus = typeof ApiFlexKybStatus[keyof typeof ApiFlexKybStatus];

export namespace ApiFlexKybStatus {
  export type FLEX_KYB_STATUS_UNSPECIFIED = typeof ApiFlexKybStatus.FLEX_KYB_STATUS_UNSPECIFIED;
  export type flex_kyb_waiting = typeof ApiFlexKybStatus.flex_kyb_waiting;
}

export function apiFlexKybStatusFromJSON(object: any): ApiFlexKybStatus {
  switch (object) {
    case 0:
    case "FLEX_KYB_STATUS_UNSPECIFIED":
      return ApiFlexKybStatus.FLEX_KYB_STATUS_UNSPECIFIED;
    case 1:
    case "flex_kyb_waiting":
      return ApiFlexKybStatus.flex_kyb_waiting;
    default:
      return ApiFlexKybStatus.FLEX_KYB_STATUS_UNSPECIFIED;
  }
}

export function apiFlexKybStatusToJSON(object: ApiFlexKybStatus): string {
  switch (object) {
    case ApiFlexKybStatus.FLEX_KYB_STATUS_UNSPECIFIED:
      return "FLEX_KYB_STATUS_UNSPECIFIED";
    case ApiFlexKybStatus.flex_kyb_waiting:
      return "flex_kyb_waiting";
    default:
      return "FLEX_KYB_STATUS_UNSPECIFIED";
  }
}

/** Request for getting KYB information for an organization. */
export interface ApiGetKybRequest {
}

/** Response containing KYB information. */
export interface ApiGetKybResponse {
  /** The KYB status */
  readonly kybStatus: ApiKybStatus;
  /** The FLEX KYB status */
  readonly flexKybStatus?:
    | ApiFlexKybStatus
    | null
    | undefined;
  /** Whether the organization is unreferenced */
  readonly unreferenced: boolean;
  /** Timestamp when the association typeform was filled */
  readonly associationTypeformFilledAt?:
    | Date
    | null
    | undefined;
  /** URL of the association typeform */
  readonly associationTypeformUrl?:
    | string
    | null
    | undefined;
  /** URL of the typeform */
  readonly typeformUrl?:
    | string
    | null
    | undefined;
  /** Ongoing KYC/KYB update process ID */
  readonly ongoingKycKybUpdateProcessId?: string | null | undefined;
}

export const ApiGetKybRequest: MessageFns<ApiGetKybRequest> = {
  fromJSON(_: any): ApiGetKybRequest {
    return {};
  },

  toJSON(_: ApiGetKybRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetKybResponse: MessageFns<ApiGetKybResponse> = {
  fromJSON(object: any): ApiGetKybResponse {
    return {
      kybStatus: isSet(object.kybStatus) ? apiKybStatusFromJSON(object.kybStatus) : ApiKybStatus.KYB_STATUS_UNSPECIFIED,
      flexKybStatus: isSet(object.flexKybStatus) ? apiFlexKybStatusFromJSON(object.flexKybStatus) : null,
      unreferenced: isSet(object.unreferenced) ? globalThis.Boolean(object.unreferenced) : false,
      associationTypeformFilledAt: isSet(object.associationTypeformFilledAt)
        ? fromJsonTimestamp(object.associationTypeformFilledAt)
        : null,
      associationTypeformUrl: isSet(object.associationTypeformUrl)
        ? globalThis.String(object.associationTypeformUrl)
        : null,
      typeformUrl: isSet(object.typeformUrl) ? globalThis.String(object.typeformUrl) : null,
      ongoingKycKybUpdateProcessId: isSet(object.ongoingKycKybUpdateProcessId)
        ? globalThis.String(object.ongoingKycKybUpdateProcessId)
        : null,
    };
  },

  toJSON(message: ApiGetKybResponse): unknown {
    const obj: any = {};
    if (message.kybStatus !== undefined && message.kybStatus !== null) {
      obj.kybStatus = apiKybStatusToJSON(message.kybStatus);
    }
    if (message.flexKybStatus !== undefined && message.flexKybStatus !== null) {
      obj.flexKybStatus = apiFlexKybStatusToJSON(message.flexKybStatus);
    }
    if (message.unreferenced !== undefined && message.unreferenced !== null) {
      obj.unreferenced = message.unreferenced;
    }
    if (message.associationTypeformFilledAt !== undefined && message.associationTypeformFilledAt !== null) {
      obj.associationTypeformFilledAt = message.associationTypeformFilledAt.toISOString();
    }
    if (message.associationTypeformUrl !== undefined && message.associationTypeformUrl !== null) {
      obj.associationTypeformUrl = message.associationTypeformUrl;
    }
    if (message.typeformUrl !== undefined && message.typeformUrl !== null) {
      obj.typeformUrl = message.typeformUrl;
    }
    if (message.ongoingKycKybUpdateProcessId !== undefined && message.ongoingKycKybUpdateProcessId !== null) {
      obj.ongoingKycKybUpdateProcessId = message.ongoingKycKybUpdateProcessId;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
